import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Catalog from "@/pages/Catalog";
import CourseDetail from "@/pages/CourseDetail";
import Checkout from "@/pages/Checkout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyCertificate from "@/pages/VerifyCertificate";
import VerifyInstructor from "@/pages/VerifyInstructor";
import StudentDashboard from "@/pages/StudentDashboard";
import CoursePlayer from "@/pages/CoursePlayer";
import TeacherPanel from "@/pages/TeacherPanel";
import AdminPanel from "@/pages/AdminPanel";
import CourseEditor from "@/pages/CourseEditor";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster richColors position="top-right" />
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/courses/:id" element={<CourseDetail />} />
              <Route path="/checkout/:courseId" element={<Checkout />} />
              <Route path="/redeem" element={<Checkout />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify/:id" element={<VerifyCertificate />} />
              <Route path="/verify-instructor/:id" element={<VerifyInstructor />} />
              <Route path="/dashboard" element={<ProtectedRoute roles={["student"]}><StudentDashboard /></ProtectedRoute>} />
              <Route path="/learn/:courseId" element={<ProtectedRoute roles={["student", "admin"]}><CoursePlayer /></ProtectedRoute>} />
              <Route path="/instructor" element={<ProtectedRoute roles={["instructor"]}><TeacherPanel /></ProtectedRoute>} />
              <Route path="/instructor/courses/:courseId" element={<ProtectedRoute roles={["instructor", "admin"]}><CourseEditor /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminPanel /></ProtectedRoute>} />
            </Routes>
          </Layout>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
